import { useMutation, useDebouncedMutate } from 'common/hooks';
import { verifyCompanyNameApi } from '../companies.service';

export const useVerifyCompanyName = () => {
  const mutationResponse = useMutation(verifyCompanyNameApi, {
    showErrorSnackbar: false,
  });
  const debouncedMutate = useDebouncedMutate(mutationResponse.mutate);

  return {
    ...mutationResponse,
    debouncedMutate,
  };
};
